import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcServers = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M5 3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H5Zm2 3.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M5 9.5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H5ZM7 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
  fill: "var(--mds-nav-icon-medium)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M5 16a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H5Zm2 3.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
})), "IcServers");

export { IcServers };
//# sourceMappingURL=ic-servers.js.map
